import { _get, _put, _post } from "../../../../http";

// porcentaje de ganancia plantel
export const getDatosDeEnvioPlantel = (plantelId) => _get(`/plantel/${plantelId}/datosEnvio`);

export const postDatosDeEnvioPlantel = (plantelId, body) => _post(`/plantel/${plantelId}/datosEnvio`, body);

export const putDatosDeEnvioPlantel = (plantelId, datosEnvioId, body) =>
  _put(`/plantel/${plantelId}/datosEnvio/${datosEnvioId}`, body);
